export const LK_DOMAIN = 'lk.doorhan.ru'
export const LKM_DOMAIN = 'lkm.doorhan.ru'
